// VajraShopProduct.jsx — Phase 59C
// 法宝详情页 — 展示法宝信息 + 「我想请」联系方式展开

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API } from '../../constants/config';

const GD  = '#8B6914';
const GDH = '#D4AF37';
const BG  = '#FDFBF7';

const CATEGORY_LABELS = {
  vase: '宝瓶', instrument: '法器', text: '法本',
  thangka: '唐卡', mala: '念珠', other: '其他',
};

export default function VajraShopProduct({ lang }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct]       = useState(null);
  const [loading, setLoading]       = useState(true);
  const [showContact, setShowContact] = useState(false);
  const [activeImage, setActiveImage] = useState(0);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API}/vajra/shop/products/${id}`);
        if (res.ok) setProduct(await res.json());
        else navigate('/vajra/shop', { replace: true });
      } catch {
        navigate('/vajra/shop', { replace: true });
      }
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#aaa' }}>加载中...</div>;
  if (!product) return null;

  const allImages = [
    ...(product.image_url ? [product.image_url] : []),
    ...(product.images_json || []),
  ];
  const statusLabel = { available: '🟢 可请', reserved: '🟡 待确认', sold: '⚫ 已请' }[product.status] || product.status;

  return (
    <div style={{ maxWidth: 860, margin: '0 auto', padding: '24px 16px 80px', background: BG, minHeight: '100vh', fontFamily: 'system-ui, sans-serif' }}>
      {/* Back */}
      <button
        onClick={() => navigate('/vajra/shop')}
        style={{ background: 'none', border: 'none', color: GD, fontSize: 13, cursor: 'pointer', padding: '4px 0', marginBottom: 20 }}>
        ← 法宝列表
      </button>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 32, alignItems: 'start' }}>
        {/* Left: Images */}
        <div>
          {allImages.length > 0 ? (
            <>
              <img
                src={allImages[activeImage]}
                alt={lang === 'en' && product.name_en ? product.name_en : product.name_zh}
                style={{ width: '100%', height: 280, objectFit: 'cover', borderRadius: 12, marginBottom: 10 }} />
              {allImages.length > 1 && (
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {allImages.map((url, i) => (
                    <img key={i} src={url} alt="" onClick={() => setActiveImage(i)}
                      style={{ width: 56, height: 56, objectFit: 'cover', borderRadius: 6, cursor: 'pointer',
                        border: i === activeImage ? `2px solid ${GD}` : '2px solid transparent', opacity: i === activeImage ? 1 : 0.6 }} />
                  ))}
                </div>
              )}
            </>
          ) : (
            <div style={{ width: '100%', height: 200, background: 'rgba(139,105,20,0.04)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ fontSize: 48, opacity: 0.25 }}>🏺</span>
            </div>
          )}
        </div>

        {/* Right: Info */}
        <div>
          <div style={{ fontSize: 11, color: 'rgba(139,105,20,0.45)', letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 6 }}>
            {CATEGORY_LABELS[product.category] || product.category}
          </div>
          <h1 style={{ fontSize: 22, color: '#333', margin: '0 0 4px', fontWeight: 600 }}>{lang === 'en' && product.name_en ? product.name_en : product.name_zh}</h1>
          {product.name_en && (
            <p style={{ fontSize: 13, color: 'rgba(139,105,20,0.5)', margin: '0 0 16px' }}>{product.name_en}</p>
          )}

          {(lang === 'en' && product.description_en ? product.description_en : product.description_zh) && (
            <p style={{ fontSize: 13, color: '#555', lineHeight: 1.8, margin: '0 0 20px' }}>
              {lang === 'en' && product.description_en ? product.description_en : product.description_zh}
            </p>
          )}

          {/* 金额 */}
          {product.suggested_amount_cad ? (
            <div style={{ fontSize: 14, color: GD, marginBottom: 10 }}>
              建议供养：CAD {product.suggested_amount_cad}
            </div>
          ) : (
            <div style={{ fontSize: 13, color: 'rgba(139,105,20,0.4)', marginBottom: 10 }}>
              随喜供养
            </div>
          )}

          {/* 状态 */}
          <div style={{ fontSize: 13, color: '#555', marginBottom: 24 }}>
            状态：{statusLabel}
          </div>

          {/* 我想请 */}
          {product.status === 'available' && (
            <div>
              <button
                onClick={() => setShowContact(c => !c)}
                style={{
                  padding: '10px 24px', borderRadius: 8, border: `1px solid ${GD}`,
                  background: showContact ? GDH : 'transparent',
                  color: showContact ? '#fff' : GD,
                  fontSize: 14, cursor: 'pointer', transition: 'all 0.2s',
                }}>
                💬 我想请此法宝
              </button>

              {showContact && (
                <div style={{
                  marginTop: 14, padding: '14px 16px',
                  background: 'rgba(212,175,55,0.05)',
                  border: '1px solid rgba(212,175,55,0.15)',
                  borderRadius: 10, fontSize: 13, color: '#555', lineHeight: 2,
                }}>
                  <p style={{ margin: '0 0 8px', color: GD, fontWeight: 500 }}>
                    请通过以下方式联系，确认法宝是否仍在：
                  </p>
                  <div>✉️ 邮件：<a href="mailto:canada.btf@gmail.com" style={{ color: GD }}>canada.btf@gmail.com</a></div>
                  <div>💬 微信：如意宝金刚社群群组</div>
                  <p style={{ margin: '10px 0 0', fontSize: 12, color: 'rgba(139,105,20,0.4)' }}>
                    （线下完成供养与交付）
                  </p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
